<template>
  <div>
    <v-container grid-list-md>
      <v-layout row wrap>
        <v-flex xs6>
          <v-btn flat to="/promotion" exact class="ma-0">  
            <v-icon color="grey lighten-1" class="mr-3">fas fa-angle-left</v-icon>
            <div class="headline">{{ name }}</div>
          </v-btn>
        </v-flex>
        <v-flex xs6 class="test-xs-right">
          <agences-list v-model="agence"></agences-list>
        </v-flex>
        <v-flex xs12 lg6>
          <v-card>
            <v-container fluid grid-list-md>
              <v-layout row wrap align-center>
                <v-flex xs8>
                  <div class="headline">{{ indicateurPromotion(this.agence, this.id) }} Lots</div>
                  <div>Objectif à date : {{ indicateurPromotion(this.agence, this.objectifsName) }}</div>
                  <div>Objectif annuel : {{ indicateurPromotion(this.agence, this.objectifsName, 12) }}</div>
                </v-flex>
                <v-flex xs4 class="text-xs-center">
                  <progress-chart :data="indicateurPromotion(this.agence, this.id)/indicateurPromotion(this.agence, this.objectifsName)" :width="74" :height="74"></progress-chart>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card>
        </v-flex>
        <v-flex xs12 lg6>
          <v-card>
            <v-container fluid grid-list-sm>
              <v-layout row wrap>
                <v-flex xs12>
                  <line-chart :data="chartData"></line-chart>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
// @ is an alias to /src
import LineChart from '@/components/charts/LineChart.js'
import ProgressChart from '@/components/charts/ProgressChart'
import { mapGetters } from 'vuex'

export default {
  name: 'PromotionDetails',
  components: {
    LineChart, ProgressChart
  },
  props: {
    id: String
  },
  data() {
    return {
      agence : 'Toutes',
    }
  },
  computed: {
    ...mapGetters(['indicateurPromotion', 'seriePromotion']),
    name() {
      let name = '';
      switch (this.id) {
        case 'PUV':
          name = 'PUV'
          break

        case 'PC':
          name = 'Dépôt PC'
          break

        case 'com':
          name = 'Com.'
          break

        case 'achat':
          name = 'Achat'
          break

        case 'demarrage':
          name = 'Démarrage'
          break

        case 'livraison':
          name = 'Livraison'
          break
      
        default:
          break
      }
      return name
    },
    objectifsName() {
      return 'objectifs' + this.$lodash.upperFirst(this.id)
    },
    chartData() {
      return {
        labels: ['Janvier', 'Février', 'Mars', 'Avril', 'Mai', 'Juin', 'Juillet', 'Août', 'Septembre', 'Octobre', 'Novembre', 'Décembre'],
        datasets: [
          {
            label: 'Lots',
            backgroundColor: '#E53935',
            data: this.seriePromotion(this.agence, this.id)
          },
          {
            label: 'Objectifs',
            backgroundColor: '#FFCC80',
            data: this.seriePromotion(this.agence, this.objectifsName)
          },
        ]
      }
    },
  }
}
</script>

<style scoped>

</style>
